import IndexDatePicker from './IndexDatePicker'

export default IndexDatePicker
